var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4444 5H6.55556C5.7 5 5 5.68571 5 6.52381V17.1905C5 18.0286 5.7 18.7143 6.55556 18.7143H9.66667L12 21L14.3333 18.7143H17.4444C18.3 18.7143 19 18.0286 19 17.1905V6.52381C19 5.68571 18.3 5 17.4444 5ZM12.7778 17.1905H11.2222V15.6667H12.7778V17.1905ZM14.4111 11.3238L13.7111 12.0095C13.0889 12.5429 12.7778 13 12.7778 14.1429H11.2222V13.7619C11.2222 12.9238 11.5333 12.1619 12.1556 11.6286L13.0889 10.6381C13.4 10.4095 13.5556 10.0286 13.5556 9.57143C13.5556 8.73333 12.8556 8.04762 12 8.04762C11.1445 8.04762 10.4445 8.73333 10.4445 9.57143H8.88892C8.88892 7.89524 10.2889 6.52381 12 6.52381C13.7111 6.52381 15.1111 7.89524 15.1111 9.57143C15.1111 10.2571 14.8 10.8667 14.4111 11.3238Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.736816e43345832bf5c60bd740bd6260.svg";
export { ForwardRef as ReactComponent };